import { Fragment, useRef, useState, useEffect } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import app from "../../api/firebaseConf";
import { collection, getFirestore, addDoc, doc, updateDoc, getDoc } from "firebase/firestore";
import { toast } from "react-toastify";
import Select from 'react-select';

export default function FormDevices(props) {

    const tipo = ['line','doughnut', 'numerico','on/off']
    const color = [{label: 'rojo', value: '#EC4646' },
                  {label: 'verde', value: '#4FC34B'},
                  {label: 'azul', value: '#3BA5FD'},
                  {label: 'amarillo', value: '#E7EA17'},
                  {label: 'naranja', value: '#F99028'}]
                  
    const on_off = [{label: 'puerta', value: 'puerta' },
    {label: 'ventana', value: 'ventana'},]

    const initState = {
        nombre: "",
        tipo: "",
        variable: "",
        habitacion: "",
        color: "",
        tipo_sw: "",
        unidad: ""
      };

      const [values, setValues] = useState(initState);
      const db = getFirestore(app)
    
      const addItems = async(object) =>{
        await addDoc(collection(db,'sensores'), object)
        toast('Nuevo dispositivo agregado', {
          type: 'success',
        })
      }

      const updDoc = async (id) => {
        await updateDoc(doc(db, "sensores", id), values);
        toast('Campo editado correctamente', {
          type: 'success'
        })
      }
    
      const cssinput = "appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white";
      const csslabel = "block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2";
    
      const handleInputChange = e => {
        const {name, value} = e.target
        setValues({...values, [name]: value})
      }
      const handleSubmit = (e) => {
        e.preventDefault();
        
        if (props.id === ""){
          addItems(values)}
        else{
          updDoc(props.id)
        }
      };

      const handleSelect = ({value},key) =>{
        setValues({...values, [key]: value})
      }

      useEffect(()=>{
        const getDocbyId = async (id) =>{
          const datos = await getDoc(doc(db,'sensores',id));
          setValues({...datos.data()})
          //console.log(datos.data())
          
        }
        
        if(props.id === ""){
          //console.log("vacio")
          setValues({...initState})
        }else {
          getDocbyId(props.id)
        }
      },[props.id])
  
  const cancelButtonRef = useRef(null)

  return (
    <Transition.Root show={props.open} as={Fragment}>
      <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={props.close}>
        {//Fondo opaco
          <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>}
        
        <div className="fixed z-10 inset-0 overflow-y-auto">
          <div className="flex items-center sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full">
                <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div className="grid justify-items-end">
                  <button 
                    type="button" 
                    className="inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 " 
                    onClick={props.close} 
                    ref={cancelButtonRef}> X </button>
                  </div>

                  {/*Formulario para dispositivos*/}
                    <form className="w-full max-w-lg" onSubmit={handleSubmit}>
                        <div className="grid grid-cols-1  gap-x-2">
                            <div>
                            <label className={csslabel}>Nombre Sensor</label>
                            <input
                                className={cssinput}
                                type="text"
                                name = "nombre"
                                placeholder="Ingrese el nombre"
                                onChange={handleInputChange}
                                value={values.nombre}
                            />
                            </div>
                            <div>
                            <label className={csslabel}>Tipo de Grafico</label>
                            <Select onChange={(e)=>handleSelect(e, 'tipo')}
                            defaultValue = {{label: 'Seleccione el grafico', value: 'empty'}} 
                            options={tipo.map( sup => ({label: sup, value: sup}) )}
                            isSearchable={false}/>
                            </div>
                        </div>

                        <div className="grid grid-cols-1">
                        <label className={csslabel}>Habitacion</label>
                          <Select onChange={(e)=>handleSelect(e, 'habitacion')}
                          defaultValue = {{label: 'Seleccione una habitacion', value: 'empty'}} 
                          options={props.seleccion.map( sup => ({label: sup, value: sup}) )}
                          isSearchable={false}/>
                        </div>
                        {/* ${values.tipo === 'on/off' ? "sm:grid-cols-1" : "sm:grid-cols-2" } */}
                        <div className={`grid grid-cols-1 py-3 gap-x-4 gap-y-2 sm:gap-y-0 sm:grid-cols-2`}>
                            { values.tipo === 'numerico' ?
                            <div>                       
                            <label className={csslabel}>Unidad de medida</label>
                            <input 
                                className={cssinput} 
                                type="text" 
                                name = "unidad"
                                placeholder="Ej: °C, PPM, V ..." 
                                onChange={handleInputChange} 
                                value={values.unidad}/>
                          </div>: values.tipo === 'on/off' ?
                             <div>
                            <label className={csslabel}>Tipo de apertura</label>
                              <Select onChange={(e)=>handleSelect(e, 'tipo_sw')}
                              defaultValue = {{label: 'Seleccione el tipo', value: 'empty'}} 
                              options={on_off.map( sup => ({label: sup.label, value: sup.value}) )}
                              isSearchable={false}
                              menuPortalTarget={document.body}
                              menuPosition='fixed'
                              styles={{
                                menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
                                menu: (provided) => ({ ...provided, zIndex: 9999 })
                              }}
                               />
                            </div>:
                            <div>
                            <label className={csslabel}>Color del Grafico</label>
                            <Select onChange={(e)=>handleSelect(e, 'color')}
                            defaultValue = {{label: 'Seleccione', value: 'empty'}} 
                            options={color.map( sup => ({label: sup.label, value: sup.value}) )}
                            isSearchable={false}
                            menuPortalTarget={document.body}
                            menuPosition='fixed'
                            styles={{
                              menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
                              menu: (provided) => ({ ...provided, zIndex: 9999 })
                            }}
                             />
                          </div>
                            
                            }
                            {
                              
                            }

                          <div>                       
                            <label className={csslabel}>Variable a medir</label>
                            <input 
                                className={cssinput} 
                                type="text" 
                                name = "variable"
                                placeholder="Ingrese variable" 
                                onChange={handleInputChange} 
                                value={values.variable}/>
                          </div>
                        </div>
                    
                        <div className=" px-4 py-3 sm:px-1 sm:flex sm:flex-row-reverse">
                            <button className="w-full inline-flex justify-center rounded-md border border-transparent 
                            shadow-sm px-4 py-2 bg-red-600 text-base font-medium 
                            text-white hover:bg-red-700 focus:outline-none focus:ring-2 
                            focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm" onClick={props.close}>
                            {props.id === "" ? "Guardar": "Editar"}
                            </button>
                        </div>
                    </form>
                </div>         
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
